/* REQ-010 · success banner with undo (Ran 20.10; position Ran 21.10: below the navbar, never over an open overlay's controls).
   A bar centred on the screen (not on the image), the icon pinned to the right, slides down from the top with a fade-in
   and fades out on exit. window.PMToast(text, undoFn?) — with undoFn the bar shows "ביטול", which runs it once. */
(function () {
  'use strict';
  if (window.PMToast) return;
  var css = '' +
    '#pmToast{position:fixed;top:10px;left:0;right:0;z-index:2147483646;display:flex;justify-content:center;padding:0 12px;pointer-events:none}' +
    '#pmToast .pm-toast{pointer-events:auto;box-sizing:border-box;width:100%;max-width:520px;display:flex;align-items:center;gap:10px;min-height:50px;padding:8px 10px 8px 12px;border-radius:14px;background:#2B2016;color:#fff;box-shadow:0 10px 30px rgba(20,14,10,.28);font:600 14px/1.35 inherit;direction:rtl;animation:pmToastIn .32s cubic-bezier(.2,.8,.2,1) both}' +
    '#pmToast .pm-toast.is-out{animation:pmToastOut .24s ease both}' +
    '#pmToast .pm-toast__ic{flex:0 0 auto;width:26px;height:26px;border-radius:50%;background:#2E6B47;display:grid;place-items:center}' +
    '#pmToast .pm-toast__t{flex:1;min-width:0;color:#fff}' +
    'body #pmToast .pm-toast__undo{all:unset;box-sizing:border-box;flex:0 0 auto;height:34px;padding:0 12px;border-radius:99px!important;border:1px solid rgba(255,255,255,.35)!important;background:transparent!important;color:#F3DFC8!important;font-size:13px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center}' +
    'body #pmToast .pm-toast__undo:focus-visible{outline:2px solid #F3DFC8;outline-offset:2px}' +
    '@keyframes pmToastIn{from{opacity:0;transform:translateY(-22px)}to{opacity:1;transform:none}}' +
    '@keyframes pmToastOut{from{opacity:1}to{opacity:0}}' +
    '@media (prefers-reduced-motion:reduce){#pmToast .pm-toast,#pmToast .pm-toast.is-out{animation-duration:.01s}}';
  var host = null, timer = 0;
  function ensure() {
    if (host) return host;
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    host = document.createElement('div'); host.id = 'pmToast'; host.setAttribute('role', 'status'); host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host); return host;
  }

  /* Position (Ran 21.10): measured when the bar is shown. Page: just below the sticky header / announcement bar (re-measured on scroll while the bar is up).
     An open overlay of ours: below its top bar (the lowest control in its top band), or, for a bottom sheet, above the sheet's top edge. */
  /* #pmIsheet.is-pop (Ran 21.10) is the product page's icon dropdown, part of the page, not an overlay */
  var OVL = '#pmEd,#pmCmp,.pm-dzm,.pm-qd,.pm-gsheet,#pmIsheet:not(.is-pop),.pm-mockview,dialog[open],.drawer,#CartDrawer,[role="dialog"][aria-modal="true"]';
  var CTL = 'button,a[href],input,textarea,select,[role="button"],[tabindex]:not([tabindex="-1"])';
  function shown(el) {
    if (!el || el.hidden || el.closest('#pmToast') || el.closest('[hidden]')) return null;
    var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return null;
    var r = el.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    if (r.width < 2 || r.height < 2 || r.right <= 0 || r.left >= vw || r.bottom <= 0 || r.top >= vh) return null;
    return r;
  }
  function headerBottom() {
    var b = 0;
    ['#SiteHeader', '.header-sticky-wrapper', '#HeaderWrapper', '.announcement-bar'].forEach(function (q) {
      var e = document.querySelector(q), r = e && shown(e);
      if (r && r.top < window.innerHeight / 2 && r.bottom > b) b = r.bottom;
    });
    return b;
  }
  function overlayTop(h) {
    var vh = window.innerHeight, bar = 0, sheet = 0, any = false;
    Array.prototype.slice.call(document.querySelectorAll(OVL)).forEach(function (o) {
      var r = shown(o); if (!r) return;
      if (r.height < 60) return;
      var panelTop = null, nodes = [o].concat(Array.prototype.slice.call(o.querySelectorAll('*')));
      for (var i = 0; i < nodes.length && i < 600; i++) {
        var n = nodes[i], nr = n === o ? r : shown(n); if (!nr || nr.height < 100 || nr.width < Math.min(window.innerWidth * 0.6, 300)) continue;
        var bg = getComputedStyle(n).backgroundColor, m = bg.match(/[\d.]+/g);
        if (!m || (m.length > 3 && +m[3] < 0.9) || bg === 'transparent') continue;
        var t = Math.max(0, nr.top); if (panelTop === null || t < panelTop) panelTop = t;
      }
      any = true;
      if (panelTop !== null && panelTop > 120) { sheet = sheet ? Math.min(sheet, panelTop) : panelTop; return; }
      Array.prototype.slice.call(o.querySelectorAll(CTL)).forEach(function (c) {
        var cr = shown(c); if (cr && cr.top < 180 && cr.bottom < 260 && cr.bottom > bar) bar = cr.bottom;
      });
      if (!bar) bar = Math.max(bar, 0);
    });
    if (!any) return null;
    if (bar) return { mode: 'bar', top: bar + 10 };
    if (sheet) return { mode: 'sheet', top: Math.max(8, sheet - h - 10) };
    return { mode: 'bar', top: 10 };
  }
  /* Ran 21.10: on the page the bar never covers the dedication block's fields (designs row, wording row, "מאת"/icon row):
     below them if there is room above the sticky add bar, else above them under the header, else at the bottom */
  function avoidBlock(top, h) {
    var U = null;
    Array.prototype.slice.call(document.querySelectorAll('#pmSpdp .pm-spdp__chipwrap, #pmSpdp .pm-spdp__bodyrow, #pmSpdp .pm-spdp__row2, #pmIsheet.is-pop .pm-isheet__box')).forEach(function (e) {
      var r = shown(e); if (!r) return; U = U ? { top: Math.min(U.top, r.top), bottom: Math.max(U.bottom, r.bottom) } : { top: r.top, bottom: r.bottom };
    });
    if (!U || top + h < U.top - 4 || top > U.bottom + 4) return top;
    var vh = window.innerHeight, hb = headerBottom();
    if (U.bottom + 10 + h < vh - 90) return U.bottom + 10;
    if (U.top - h - 10 >= hb + 4) return U.top - h - 10;
    return Math.max(hb + 10, vh - h - 90);
  }
  var mode = 'page', poll = 0; /* poll: an overlay may open or close while the bar is up */
  function place() {
    var bar = host && host.firstElementChild; if (!host) return;
    var h = bar ? bar.offsetHeight : 52, ov = overlayTop(h), top;
    if (ov) { mode = ov.mode; top = ov.top; if (ov.mode === 'sheet') top = Math.max(top, 0); }
    else { mode = 'page'; top = avoidBlock(headerBottom() + 10, h); }
    host.style.top = Math.round(top) + 'px';
  }
  var raf = 0;
  function onScroll() { if (mode !== 'page' || raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  function hide(bar) {
    if (!bar || bar.classList.contains('is-out')) return;
    bar.classList.add('is-out');
    setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 260);
  }
  window.PMToast = function (text, undo) {
    var h = ensure(); clearTimeout(timer);
    Array.prototype.slice.call(h.children).forEach(function (n) { n.parentNode.removeChild(n); });
    var bar = document.createElement('div'); bar.className = 'pm-toast';
    bar.innerHTML = '<span class="pm-toast__ic" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><span class="pm-toast__t"></span>';
    bar.querySelector('.pm-toast__t').textContent = text;
    if (typeof undo === 'function') {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pm-toast__undo'; b.textContent = 'ביטול';
      b.addEventListener('click', function () { clearTimeout(timer); hide(bar); undo(); }, { once: true });
      bar.appendChild(b);
    }
    h.appendChild(bar); place();
    clearInterval(poll); poll = setInterval(function () { if (!host || !host.firstElementChild) clearInterval(poll); else place(); }, 250);
    timer = setTimeout(function () { hide(bar); }, undo ? 5000 : 3000);
  };
})();
